(function () {

    'use strict';

    /**
     * Initiates the Slideable navigation.
     */
    const SlideableNavigation = function (element) {

        this.element = element;
        this.trigger = element.getElementsByClassName('js-slide-nav--trigger')[0];
        this.navigation = element.getElementsByClassName('js-slide-nav--navigation')[0];

        this.expandNavigation = this.expandNavigation.bind(this);
        this.collapseNavigation = this.collapseNavigation.bind(this);

        this.initiateListener();
    };

    /**
     * Initiates the event listener.
     */
    SlideableNavigation.prototype.initiateListener = function () {

        this.trigger.addEventListener('pointerdown', this.expandNavigation);
        this.trigger.addEventListener('keydown', this.expandNavigation);
    };

    /**
     * Expands the navigation
     */
    SlideableNavigation.prototype.expandNavigation = function (event) {

        event.stopPropagation();

        let expanded;

        if (this.trigger.getAttribute('aria-expanded') === 'true') {
            expanded = 'false';
        } else {
            expanded = 'true';
        }

        // Expand the mobile menu
        this.trigger.setAttribute('aria-expanded', expanded);

        window.addEventListener('keyup', this.collapseNavigation);
        window.addEventListener('pointerdown', this.collapseNavigation);
    }

    /**
     * Collapses the navigation
     */
    SlideableNavigation.prototype.collapseNavigation = function (event) {

        let collapse = false;

        if (event.type === 'keyup' && event.key === 'Escape') {
            collapse = true;
        }

        if (event.type === 'pointerdown' && event.target === this.trigger) {
            collapse = true;
        }

        // Collapse when the navigation loses focus
        if(event.type === 'pointerdown' && !event.target.closest('.js-expand-nav')) {
            collapse = true;
        }

        if (collapse) {

            // Collapse the mobile menu
            this.trigger.setAttribute('aria-expanded', 'false');

            window.removeEventListener('keyup', this.collapseNavigation);
            window.removeEventListener('pointerdown', this.collapseNavigation);
        }
    }

    const navigations = document.getElementsByClassName('js-slide-nav');

    for (const navigation of navigations) {
        new SlideableNavigation(navigation);
    }
}());